<template>
  <div class="maths_container">
    <div class="maths" id="maths">
      <!-- 게임 시작화면 -->
      <div v-show="gameMode === 'ready'" class="math_ready">
        <div class="math_ready_title" />
        <div class="math_ready_desc">
          제한 시간 60초
          <br />
          사칙연산 30문제
        </div>
        <div v-on:click="() => gamePlay()" class="math_startend_btn">
          start
        </div>
      </div>
      <!-- 게임 엔딩화면 -->
      <div v-show="gameMode === 'gameover'" class="math_gameover">
        <div class="math_gameover1">
          <div ref="mathscore" class="math_capture">
            <div class="math_gameover_text1">your score</div>
            <div class="math_gameover_text2">{{ score }}</div>
            <div class="math_gameover_text1">remain time</div>
            <div class="math_gameover_text3">
              {{ recordSec }} : {{ recordMillisec }}
            </div>
          </div>
        </div>
        <div class="math_gameover2">
          <div class="math_gameover_text1" style="margin-bottom: 10px;">
            share it with your friends
          </div>
          <share
            url="https://spready.net/maths"
            title="두뇌트레이닝 사칙연산"
            :image="image"
          />
        </div>
        <div class="math_gameover3">
          <div v-on:click="() => gameStart()" class="math_startend_btn">
            retry
          </div>
        </div>
      </div>
      <!-- 게임 화면 - 헤더 부분 -->
      <div class="maths_playing" v-if="gameMode === 'playing'">
        <div class="math_header">
          <div class="math_header_time">
            <div class="math_header_time_text">
              TIME
            </div>
            <div class="math_header_time_number">
              <Timer
                ref="timer"
                type="countdown"
                auto-start
                :length="60 * 1000"
                @done="onDone"
                v-slot="{ time, state, isDone, isOverflowed }"
              >
                <div>
                  <span
                    :class="{ 'is-overflowed': isOverflowed }"
                    style="width: 100%; display:flex; justify-content: left;"
                  >
                    <div style="width: 40%;">
                      <span>{{ time.s }}</span>
                    </div>
                    <div style="width: 5%;"><span> : </span></div>
                    <div style="width: 40%;">
                      <span>{{ time.ms.substring(0, 2) }}</span>
                    </div>
                  </span>
                </div>
              </Timer>
            </div>
          </div>
          <div class="math_header_score">
            <div class="math_header_score_text">
              SCORE
            </div>
            <div class="math_header_score_number">
              {{ score }}
            </div>
          </div>
        </div>
        <!-- 문제 부분 -->
        <div class="math_contents" ref="math_contents">
          <div class="math_contents_number">{{ num1 }}</div>
          <div class="math_contents_space" />
          <div class="math_contents_symbol">{{ symbol }}</div>
          <div class="math_contents_space" />
          <div class="math_contents_number">{{ num2 }}</div>
        </div>
        <!-- 답 입력 부분 -->
        <div class="math_bottom">
          <div class="math_bottom_answer">
            <v-text-field
              style="text-align: right; background: white; height: 50px; padding-left: 10px; padding-top: 8px; font-size: 1.5rem; border: 2px solid #333333; box-shadow: 2px 2px #333333;"
              rounded
              type="number"
              @change="handleChangeUserAnswer"
              :value="userAnswer"
              @keypress.prevent.enter="() => onSubmitAnswer()"
            />
          </div>
          <div class="math_bottom_symbol" @click="onSubmitAnswer">
            <font-awesome-icon icon="check" style="font-size: 1.2rem" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateExpression } from "../lib/math";
import { evaluate } from "mathjs";
import { TimerVue as Timer } from "@josephuspaye/timer";
import Share from "./Share";

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "Maths",
  components: {
    Timer,
    Share
  },
  data() {
    return {
      correctAnswer: 0,
      currentLevel: 0,
      userAnswer: "",
      score: 0,
      num1: 0,
      symbol: "",
      num2: 0,
      expression: "",
      positionY: "",
      gameMode: "",
      recordSec: "",
      recordMillisec: "",
      image: null
    };
  },
  mounted() {
    this.gameStart();
  },
  methods: {
    /* 시작할 때 level 0 으로 문제 생성 */
    gameStart() {
      this.gameMode = "ready";
      this.positionY = -1150;
      document.querySelector("#maths").style.backgroundPositionY =
        this.positionY + "px";
    },
    /* 새로운 문제 생성 */
    newQuestion(curlv) {
      this.expression = generateExpression({ level: curlv });
      this.correctAnswer = evaluate(this.expression);
      const idx1 = this.expression.search(" ");
      this.num1 = this.expression.substring(0, idx1);
      this.symbol = this.expression
        .substring(idx1 + 1, idx1 + 2)
        /*.replace("+", "＋")
        .replace("-", "－")*/
        .replace("*", "×")
        .replace("/", "÷");
      this.num2 = this.expression.substring(idx1 + 2);
    },
    /* 애니메이션 */
    fadeInOut() {
      this.runAnimation(this.$refs.math_contents, "fade");
    },
    runAnimation(element, className) {
      if (element && !element.classList.contains(className)) {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
        element.style.width = element.offsetWidth;
        element.classList.add(className);
      }
    },
    /* 문제 맞췄을 때 액션 */
    move() {
      this.positionY += 61.8;
      if (this.positionY <= 55) {
        /* 점수가 오르면 10점 단위로 레벨이 상승 */
        this.score += 10;
        if (this.score <= 100) {
          this.currentLevel = 0;
        } else if (this.score > 100 && this.score <= 200) {
          this.currentLevel = 1;
        } else if (this.score > 200 && this.score <= 300) {
          this.currentLevel = 2;
        }
        /* 배경화면 이동 */
        document.querySelector("#maths").style.backgroundPositionY =
          this.positionY + "px";
        /* 문제 애니메이션 */
        this.fadeInOut();
        /* 새로운 문제 생성 */
        this.newQuestion(this.currentLevel);
      }
    },
    /* 문제 틀렸을 때 액션 */
    moveback() {
      if (this.positionY > -1800) {
        this.positionY -= 61.8;
        document.querySelector("#maths").style.backgroundPositionY =
          this.positionY + "px";
        this.fadeInOut();
        this.newQuestion(this.currentLevel);
      }
      if (this.score > 0) {
        this.score -= 10;
      }
    },
    /* 유저가 입력한 답에 따라 액션 */
    handleChangeUserAnswer(answer) {
      this.userAnswer = answer;
    },
    onSubmitAnswer() {
      if (this.correctAnswer === parseFloat(this.userAnswer)) {
        this.move();
      } else {
        this.moveback();
      }
      this.userAnswer = "";
    },
    /* 게임 스타트 */
    gamePlay() {
      this.gameMode = "playing";
      this.score = 0;
      this.newQuestion(0);
    },
    onDone() {
      this.gameMode = "gameover";
      this.recordSec = "00";
      this.recordMillisec = "00";
    },
    async capture() {
      const mathscoreScreen = this.$refs.mathscore;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(mathscoreScreen, options);
      const file = dataURLtoFile(image, "mathscore.png");
      this.image = file;
    }
  },
  watch: {
    /* gamemode 변하면 배경화면 위치 이동 */
    gameMode: {
      async handler(value) {
        if (value === "ready") {
          this.positionY = -1150;
          document.querySelector("#maths").style.backgroundPositionY =
            this.positionY + "px";
        } else if (value === "playing") {
          this.positionY = -1800;
          document.querySelector("#maths").style.backgroundPositionY =
            this.positionY + "px";
        } else if (value === "gameover") {
          await this.capture();
        }
      }
    },
    score: {
      async handler(value) {
        if (value >= 300) {
          this.recordSec = this.$refs.timer.time.s;
          this.recordMillisec = this.$refs.timer.time.ms.substring(0, 2);
          this.gameMode = "gameover";
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Jua&display=swap");

.maths_container {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  background: #bbf3fc;
  display: flex;
  justify-content: center;
  align-items: top;
  text-align: center;
}
.maths {
  height: 400px;
  width: 500px;
  font-family: "Jua", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  background: url("../assets/maths/maths_bg.png") no-repeat center;
  background-position-y: -1150px;
  transition: 0.5s linear;
}
.maths_playing {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.math_ready {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  color: #ffffff;
}
.math_gameover {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  background: #7dd9ef;
}
/* 헤더, 컨텐츠, 바텀 3개로 분리 */
.math_header {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 15%;
  width: 100%;
  color: #ffffff;
  text-shadow: 2px 2px 2px gray;
}
.math_contents {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 50%;
  width: 100%;
}
.math_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 20%;
  width: 100%;
}
/* 헤더 부분 */
.math_header_time {
  width: calc(100% / 4);
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.math_header_score {
  width: calc(100% / 4);
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.math_header_time_text {
  width: 40%;
}
.math_header_time_number {
  width: 60%;
}
.math_header_score_text {
  width: 50%;
}
.math_header_score_number {
  width: 50%;
}
/* 컨텐츠 부분 */
.math_contents_symbol {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  font-weight: 600;
  font-size: 2rem;
  color: #ffffff;
  border-radius: 0.5em;
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: 2px solid brown;
  box-shadow: 2px 2px brown;
  background: linear-gradient(to right, orange 10%, tomato 100%);
}
.math_contents_number {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 50px;
  font-weight: 600;
  font-size: 1.5rem;
  color: #110075;
  border-radius: 0.5em;
  border: 2px solid #333333;
  box-shadow: 2px 2px #333333;
  box-sizing: border-box;
  background-color: #a6deff;
  background: linear-gradient(270deg, #a6deff 0%, #daf2ff 10%, #ffffff 100%);
}
.math_contents_space {
  margin-left: 25px;
}
/* 바텀 부분 */
.math_bottom_answer {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 50px;
  font-weight: 600;
  font-size: 1.5rem;
  color: #000000;
  margin-right: 25px;
}
.math_bottom_symbol {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  font-weight: 600;
  font-size: 2rem;
  color: #ffffff;
  border-radius: 0.5em;
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: 2px solid #0f9636;
  box-shadow: 2px 2px green;
  background: linear-gradient(to right, #0fe44c 10%, #0f9636 100%);
}
.math_contents.fade {
  animation: bump 0.5s forwards;
}
@keyframes bump {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  50% {
    transform: translateY(-30px);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* 게임 레디 화면 */
.math_ready_title {
  height: 120px;
  width: 100%;
  background: url("../assets/maths/math_title.png") no-repeat center top;
}
.math_ready_desc {
  font-size: 1.1rem;
  color: #ffffff;
  text-shadow: 1px 1px 0 #333333;
  margin: 20px 0;
}
/* 게임 오버 화면 */
.math_gameover_text1 {
  font-size: 1.1rem;
  color: #ffffff;
  text-shadow: 1px 1px 0 #333333;
}
.math_gameover_text2 {
  font-size: 2rem;
  color: tomato;
  text-shadow: 1px 1px 0 #000000;
}
.math_gameover_text3 {
  font-size: 1.4rem;
  color: tomato;
  text-shadow: 1px 1px 0 #000000;
}
.math_gameover1 {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 50%;
  flex-direction: column;
}
.math_gameover2 {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 25%;
  flex-direction: column;
}
.math_gameover3 {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 25%;
  flex-direction: column;
}
.math_startend_btn {
  width: 90px;
  height: 40px;
  font-size: 1rem;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-radius: 1em;
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  box-shadow: 2px 2px brown;
  background: linear-gradient(to right, orange 10%, tomato 100%);
  cursor: pointer;
}
/* 캡쳐 화면 */
.math_capture {
  padding: 45px 80px 40px 80px;
  background: url("../assets/maths/maths_end.png") no-repeat center top;
}
</style>
